import _ from "lodash";
import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  CONTRIBUTE_GRAB_TEXT,
  CONT_BARCODE_READ,
  CONT_INITIALIZATION,
  CONT_SEND_DATA,
  CONT_CLEAR,
  CONT_RESTAURANT_ADD_IMAGE,
  CONT_RESTAURANT_SUBMIT,
  CONT_RESTAURANT_DEL_IMAGE,
  CONTRIBUTE_CATEGORY_SELECTED,
  IS_UNSAVED,
  CHECK_IS_DRAFT_DIRTY,
  BARCODE_READ,
  CLEAR_CONT_DIRTY_DRAFT,
  PCP_UNITS,
  DRUG_UNITS,
  SUP_UNITS,
  FOOD_UNITS,
} from "../actions/constant";
import i18n from "../i18n";

const initialState = {
  isLoading: false,
  googleText: "",
  localText: "",
  notAllowed: false,
  notAllowedByUser: false,
  barcode: false,
  disabledAlert: false,
  contData: { name: "", ingredient: "", nutrition: "", category: null },
  thank: false,
  barcodeFailed: false,
  repeatedBarcode: false,
  restaurant: { menu: [], name: null },
  amountReseter: false,
  cameFrom: false,
  goBackAlert: false,
  failedGetTextFromImg: false,
};

function reducer(state = initialState, action) {
  function unsavedDataChecker(isRedirected, redirectedFrom) {
    let previousPageIsDirty = sessionStorage.getItem("previousPageIsDirty");
    let redirectedPage = redirectedFrom;
    if (previousPageIsDirty === "null" || previousPageIsDirty === null) {
    } else {
      redirectedPage =
        previousPageIsDirty === "input"
          ? i18n.t("menu.INPUT")
          : previousPageIsDirty === "edit"
            ? i18n.t("general.EDIT")
            : previousPageIsDirty === "createRecipe"
              ? i18n.t("recipe.CREATE_RECIPE_PAGE_TITLE")
              : previousPageIsDirty === "createRegimen"
                ? i18n.t("recipe.CREATE_REGIMEN_PAGE_TITLE")
                : previousPageIsDirty === "editRegimen"
                  ? i18n.t("recipe.EDIT_REGIMEN_PAGE_TITLE")
                  : previousPageIsDirty === "editRecipe"
                    ? i18n.t("recipe.EDIT_RECIPE_PAGE_TITLE")
                    : i18n.t("meal_planner.PAGE_TITLE");
    }

    let vAlertMessages = {
      title: i18n.t("contribute.UNSAVED_CONT_DATA_TITLE"),
      text: i18n.t("contribute.UNSAVED_CONT_DATA_TEXT"),
      page: "contribute",
      redirectedFrom: redirectedPage,
    };

    const hasAnyImageOrData =
      !!state.barcode ||
      !!state.restaurant.name ||
      (state.restaurant &&
        Array.isArray(state.restaurant.menu) &&
        state.restaurant.menu.length > 0) ||
      (state.contData &&
        (
          (state.contData.name && (state.contData.name.img || (typeof state.contData.name === "string" && state.contData.name.trim() !== ""))) ||
          (state.contData.ingredient && (state.contData.ingredient.img || (typeof state.contData.ingredient === "string" && state.contData.ingredient.trim() !== ""))) ||
          (state.contData.nutrition && (state.contData.nutrition.img || (typeof state.contData.nutrition === "string" && state.contData.nutrition.trim() !== "")))
        ));

    if (hasAnyImageOrData) {
      IS_UNSAVED("yes");
      localStorage.setItem("unsavedAlertData", JSON.stringify(vAlertMessages));
    } else {
      localStorage.removeItem("unsavedAlertData");
      localStorage.removeItem("dataChanged");
      IS_UNSAVED(false);
    }
  }
  switch (action.type) {
    case getStarted(CONT_INITIALIZATION):
      return initialState;
    case getSucceeded(CONT_INITIALIZATION):
      let isRedirected = action.payload.data;
      let contDefault = localStorage.getItem("contDefault");
      if (contDefault) {
        let defaultVal = JSON.parse(contDefault);
        state.barcode = defaultVal.barcode;
        state.contData.category = defaultVal.category;
        state.cameFrom = defaultVal.page;
      }
      let previousPageIsDirty = sessionStorage.getItem("previousPageIsDirty");

      if (previousPageIsDirty === "null" || previousPageIsDirty === null) {

        unsavedDataChecker();
      } else {
        let pageName =
          previousPageIsDirty === "input"
            ? i18n.t("menu.INPUT")
            : previousPageIsDirty === "edit"
              ? i18n.t("general.EDIT")
              : previousPageIsDirty === "createRecipe"
                ? i18n.t("recipe.CREATE_RECIPE_PAGE_TITLE")
                : previousPageIsDirty === "createRegimen"
                  ? i18n.t("recipe.CREATE_REGIMEN_PAGE_TITLE")
                  : previousPageIsDirty === "editRegimen"
                    ? i18n.t("recipe.EDIT_REGIMEN_PAGE_TITLE")
                    : previousPageIsDirty === "editRecipe"
                      ? i18n.t("recipe.EDIT_RECIPE_PAGE_TITLE")
                      : i18n.t("meal_planner.PAGE_TITLE");

        unsavedDataChecker(isRedirected, pageName);
      }
      return { ...state, amountReseter: !state.amountReseter };
    case getEnded(CONT_INITIALIZATION):
      return { ...state, amountReseter: !state.amountReseter };

    case getStarted(CONTRIBUTE_GRAB_TEXT):
      return {
        ...state,
        isLoading: true,
        failedGetTextFromImg: false,
      };
    case getSucceeded(CONTRIBUTE_GRAB_TEXT):
      if (action.payload.data) {
        state.contData[action.payload.part] = action.payload.data;
      } else if (action.payload.errorMessage) {
        state.failedGetTextFromImg = true;
      }
      unsavedDataChecker();
      return { ...state };
    case getFailed(CONTRIBUTE_GRAB_TEXT):
      return {
        ...state,
        failedGetTextFromImg: true,
      };
    case getEnded(CONTRIBUTE_GRAB_TEXT):
      return { ...state, isLoading: false, repeatedBarcode: false };
    case getStarted(CONT_BARCODE_READ):
      return {
        ...state,
        isLoading: true,
        barcodeFailed: false,
        notAllowed: false,
        notAllowedByUser: false,
        repeatedBarcode: false,
      };
    case getSucceeded(CONT_BARCODE_READ):
      let data = action.data;
      if (
        data.is_ref &&
        data.number_of_contribute &&
        data.number_of_contribute >= 1
      ) {
        state.barcode = false;
        state.repeatedBarcode = true;
      } else if (
        !data.is_ref &&
        data.number_of_contribute &&
        data.number_of_contribute > 3
      ) {
        state.barcode = false;
        state.notAllowed = true;
      } else if (
        !data.is_ref &&
        data.is_own &&
        data.number_of_contribute &&
        data.number_of_contribute > 0 &&
        data.number_of_contribute < 4
      ) {
        state.barcode = false;
        state.notAllowedByUser = true;
      } else {
        let barnum = data.upc;
        state.barcode = barnum;
      }

      unsavedDataChecker();
      return { ...state, isLoading: false };
    case getFailed(CONT_BARCODE_READ):
      // Clear the previously entered barcode on any read failure
      state.barcode = false;
      if (action.data.msg && action.data.msg == "USER_ALREADY_CONTRIBUTED") {
        state.notAllowedByUser = true;
      } else {
        state.barcodeFailed = true;   // shows BARCODE_ERROR_TITLE
      }
      unsavedDataChecker();           // keep unsaved flag in sync
      return { ...state, isLoading: false };
    case getEnded(CONT_BARCODE_READ):
      return { ...state, isLoading: false };
    case getStarted(BARCODE_READ):
      return { ...state, isLoading: true };
    case getSucceeded(BARCODE_READ):
      return { ...state, isLoading: false };
    case getFailed(BARCODE_READ):
      return { ...state, isLoading: false };
    case getEnded(BARCODE_READ):
      return { ...state, isLoading: false };
    case getStarted(CONT_SEND_DATA):
      return { ...state, isLoading: true };
    case getSucceeded(CONT_SEND_DATA):
      let defaultData = JSON.parse(localStorage.getItem("contDefault"));
      if (defaultData) {
        let data = {
          ...defaultData,
          barcode: action.payload.data.upc,
          category: action.payload.data.category,
          name: action.payload.data.name,
          sName: action.payload.data.name,
          fullname: action.payload.data.full_name,
          upc: action.payload.data.upc,
        };
        localStorage.setItem("contDefault", JSON.stringify(data));
      }

      unsavedDataChecker();

      return {
        ...state,
        thank: true,
      };
    case getFailed(CONT_SEND_DATA):
      alert("Action failed, try again");
      return { ...state };
    case getEnded(CONT_SEND_DATA):
      return { ...state, isLoading: false };
    case CONT_CLEAR:
      // state.contData.category = null;
      IS_UNSAVED("no");
      // unsavedDataChecker();
      return {
        ...state,
        isLoading: false,
        notAllowed: false,
        barcode: false,
        disabledAlert: false,
        contData: { name: {}, ingredient: {}, nutrition: {}, category: "null" },
        restaurant: { menu: [], name: null },
        // thank: false,
        barcodeFailed: false,
      };
    case getStarted(CONT_RESTAURANT_ADD_IMAGE):
      return { ...state, isLoading: true, failedGetTextFromImg: false };
    case getSucceeded(CONT_RESTAURANT_ADD_IMAGE):
      if (action.payload.name === "name") {
        state.restaurant.name = action.payload.file;
      } else if (action.payload.name === "menu") {
        const file = action.payload.file;
        const newImages = [...state.restaurant.menu];
        newImages.push(file);
        state.restaurant.menu = newImages;
      }

      // If backend reported OCR error for either restaurant name or any menu image
      state.failedGetTextFromImg = !!action.payload.errorMessage;

      unsavedDataChecker();
      return { ...state, isLoading: false };
    case getStarted(CONT_RESTAURANT_SUBMIT):
      return { ...state, isLoading: true };
    case getSucceeded(CONT_RESTAURANT_SUBMIT):
      state.restaurant = { menu: [], name: null };
      // setTimeout(() => {
      //   window.location.href = `/contribute`;
      // }, 1000);
      unsavedDataChecker();

      return { ...state, thank: true };
    case getEnded(CONT_RESTAURANT_SUBMIT):
      return { ...state, isLoading: false };
    case getSucceeded(CONT_RESTAURANT_DEL_IMAGE):
      let menu = state.restaurant.menu;
      if (action.payload.name === "name") {
        state.restaurant.name = null;
      } else if (action.payload.name === "menu") {
        menu = menu.filter((item) => item !== action.payload.file);
        state.restaurant.menu = menu;
      }
      unsavedDataChecker();

      return { ...state, isLoading: false };
    case CHECK_IS_DRAFT_DIRTY:
      const hasAnyImage =
        !!state.barcode ||
        !!state.restaurant.name ||
        (state.restaurant && Array.isArray(state.restaurant.menu) && state.restaurant.menu.length > 0) ||
        (state.contData &&
          (
            (state.contData.name && state.contData.name.img) ||
            (state.contData.ingredient && state.contData.ingredient.img) ||
            (state.contData.nutrition && state.contData.nutrition.img)
          ));

      return {
        ...state,
        isLoading: false,
        goBackAlert: !!hasAnyImage
      };
    case CLEAR_CONT_DIRTY_DRAFT:
      if (state.restaurant.name) {
        setTimeout(() => {
          state.restaurant.name = null;
          unsavedDataChecker();
        }, 1000);
      }

      return {
        ...state,
        isLoading: false,
        goBackAlert: false,
        thank: false,
        restaurant: { menu: [], name: null },
      };

    case CONTRIBUTE_CATEGORY_SELECTED:
      state.contData.category = action.value;
      let list_units = [];
      if (action.value == "02") {
        list_units = FOOD_UNITS();
      } else if (action.value == "04") {
        list_units = PCP_UNITS();
      } else if (action.value == "05") {
        list_units = DRUG_UNITS();
      } else if (action.value == "06") {
        list_units = SUP_UNITS();
      }

      defaultData = JSON.parse(localStorage.getItem("contDefault"));
      if (defaultData) {
        let unitOptions = [];
        list_units.map((unit) => {
          unitOptions.push({ value: unit._id, label: unit.unit });
        });
        let data = {
          ...defaultData,
          contCategory: action.value,
          unitOptions: unitOptions,
        };
        localStorage.setItem("contDefault", JSON.stringify(data));
      }
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/contributeReducer.js